import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=f35c93aa&"
import script from "./Posts.vue?vue&type=script&lang=ts&"
export * from "./Posts.vue?vue&type=script&lang=ts&"
import style0 from "./Posts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports